export default "__VITE_ASSET__Bp$DSR2V__"